import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { F3LoadingInterceptor } from '@f3/services/loading/loading.interceptor';

@NgModule({
    providers: [
        {
            provide : HTTP_INTERCEPTORS,
            useClass: F3LoadingInterceptor,
            multi   : true
        }
    ]
})
export class F3LoadingModule
{
}
